var _rect, _g, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "Pandas",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#150458"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 7,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 7,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 10,
    width: 7,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 38,
    width: 7,
    height: 16
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 29,
    width: 7,
    height: 6,
    fill: "#ffca00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 29,
    width: 7,
    height: 6,
    fill: "#ffca00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 19,
    width: 7,
    height: 26,
    fill: "#e70488"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/pandas.6174f0a8d6f23a60f5ab4fe4c891ef90.svg";
export { ForwardRef as ReactComponent };